<div class="respondents-by-grade-module">
    <div class="title">{{ 'lang.reporting.gradesPie' | translate }}</div>
  <div class="overall-rating-bar">
    <canvas id="gradesPie" [width]="pieWidth"></canvas>
    <img hidden id="pieGradeChart"/>
  </div>
</div>